// extracted by mini-css-extract-plugin
export default {"dividerLine":"HeaderMetadataDivider-module__dividerLine__PMNBVF3"};